import { IBuilderLibraries, IStupidEdiConfigs, Maybe } from 'types/graphqlTypes'
import { boolean, object, string, mixed } from 'yup'

export interface IConfigurableBuilderVersionSchema {
  builderLibrary: IBuilderLibraries
  ediMapperConfigurableBuilderId: string
  extractionTemplate: string
  id: string
  isLive: boolean
  stupidediConfig?: Maybe<IStupidEdiConfigs>
  wasEverLive: boolean
  tfx12DefinitionId?: Maybe<string>
  canBuildBalanceDues: boolean
}

export const ConfigurableBuilderVersionSchema = object<IConfigurableBuilderVersionSchema>({
  ediMapperConfigurableBuilderId: string(),
  extractionTemplate: string().required('Extraction template is required'),
  id: string(),
  isLive: boolean(),
  stupidediConfig: mixed<IStupidEdiConfigs>().oneOf(Object.values(IStupidEdiConfigs)),
  wasEverLive: boolean(),
  builderLibrary: mixed<IBuilderLibraries>()
    .oneOf(Object.values(IBuilderLibraries))
    .required('Builder Library is required')
    .default('stupidedi'),
  tfx12DefinitionId: string(),
  canBuildBalanceDues: boolean(),
})
